import { render, staticRenderFns } from "./DataLeft.vue?vue&type=template&id=34239b1e&scoped=true"
import script from "./DataLeft.vue?vue&type=script&lang=js"
export * from "./DataLeft.vue?vue&type=script&lang=js"
import style0 from "./DataLeft.vue?vue&type=style&index=0&id=34239b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34239b1e",
  null
  
)

export default component.exports